import { IOfferForClientSchema } from '../../repositories/chats/entities/for_client/OfferForClientSchema';
import { IOfferSchema } from '../../repositories/chats/entities/get_my_offers_for_selection/OfferSchema';

export const modifyOffer = (offer: IOfferSchema): IOfferForClientSchema => {
  // модифицирует формат оффера из селектору к виду оффера для чата

  const { photoUrl, ...restOfferData } = offer;

  return {
    ...restOfferData,
    photoUrls: photoUrl ? [photoUrl] : [],
  };
};
